import React from 'react';
import { Link, RouteComponentProps } from '@reach/router';

interface Props extends RouteComponentProps {
   to: string;
}

const NavLink: React.FC<Props> = (props): JSX.Element => (
   <Link
      {...props}
      getProps={({ isPartiallyCurrent }) => ({
         style: {
            fontWeight: isPartiallyCurrent ? 'bolder' : 600,
         },
      })}
   />
);

export default NavLink;
